import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/browser';
import logger from '../core/logger/index';
import { ERROR_CAUGHT } from '../core/analytics/events';
import { analyticsTrackEvent } from '../core/analytics';

class ErrorBoundary extends PureComponent {
  static propTypes = {
    children: PropTypes.any.isRequired,
    fallbackUI: PropTypes.any,
  };

  static getDerivedStateFromError = (error: any) => {
    return { hasError: true, error };
  };

  constructor(props: any) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  componentDidCatch = (error: any, info: any) => {
    logger.error(
      `Error caught by ErrorBoundary: \n
      Error: ${JSON.stringify(error)} \n
      Info: ${JSON.stringify(info)}`
    );
    analyticsTrackEvent(ERROR_CAUGHT, { error, info });

    Sentry.captureException(error);
  };

  render = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'hasError' does not exist on type 'Readon... Remove this comment to see the full error message
    const { hasError, error } = this.state;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'fallbackUI' does not exist on type 'Read... Remove this comment to see the full error message
    const { children, fallbackUI } = this.props;

    if (hasError) {
      return React.cloneElement(fallbackUI, { error });
    }

    return children;
  };
}

export default ErrorBoundary;
